/* eslint-disable max-len */
import { useLazyQuery } from "@apollo/client";
import { GET_PAST_WELLNESS_PLANS } from "./wellness-plans-past.query";
import { IPastWellnessPlansResponse } from "./wellness-plans-past.interface";


const usePastWellnessPlans = () => {
  const [getPastWellnessPlans, { data, loading, error }] = useLazyQuery<{ getPastWellnessPlans: IPastWellnessPlansResponse }>(GET_PAST_WELLNESS_PLANS);

  return {
    getPastWellnessPlans,
    pastWellnessPlans: data?.getPastWellnessPlans?.pastWellnessPlans || [],
    loading,
    error,
  };
};

export default usePastWellnessPlans;
